export default __webpack_public_path__ + "static/media/facebookIcon.9a730938.svg";